export default "__VITE_ASSET__DmSimKVR__"